import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn } from 'react-icons/fa';
import ScrollReveal from './ScrollReveal';
import { useRegion } from '../context/RegionContext';
import { allProducts } from '../config/productsMenuConfig';
import './Footer.css';

const Footer = () => {
  const { data } = useRegion();

  return (
    <ScrollReveal as="footer" className="footer-section" variant="fadeIn" delay={0.1}>
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo.png" alt="Proven Logo" className="footer-logo-img" />
              <img src="/logoname.png" alt="Proven Infosec" className="footer-logo-name" />
            </div>
            <p className="footer-tagline">Your Security Partner Across India & the UK</p>
          </div>

          {/* Link Columns */}
          <div className="footer-links">
            <div className="footer-col">
              <h4 className="footer-col-title">Free Tools</h4>
              <Link to="/free-tools" className="footer-link">All Free Tools</Link>
              <Link to="/nist-csf-assessment" className="footer-link">NIST CSF 2.0 Assessment</Link>
              <Link to="/nist-ai-rmf-assessment" className="footer-link">NIST AI RMF Assessment</Link>
              <Link to="/security-maturity-assessment" className="footer-link">Security Maturity Assessment</Link>
              <Link to="/pentest-quote" className="footer-link">Get a Pentest Quote</Link>
            </div>

            <div className="footer-col">
              <h4 className="footer-col-title">Products</h4>
              {allProducts.map((product) => (
                <Link key={product.slug} to={product.href} className="footer-link">
                  {product.label}
                </Link>
              ))}
              <Link to="/products" className="footer-link">All Products</Link>
            </div>

            <div className="footer-col">
              <h4 className="footer-col-title">Learn</h4>
              <Link to="/resources" className="footer-link">Resources</Link>
              <Link to="/threat-research" className="footer-link">Threat Research</Link>
              <Link to="/detection-dispatch" className="footer-link">Detection Dispatch</Link>
              <Link to="/webinars" className="footer-link">Webinars</Link>
              <Link to="/customers" className="footer-link">Customers</Link>
              <Link to="/industries" className="footer-link">Industries</Link>
              <Link to="/solution-guides" className="footer-link">Solution Guides</Link>
            </div>

            <div className="footer-col">
              <h4 className="footer-col-title">Customer Resources</h4>
              <Link to="/knowledge-base" className="footer-link">Knowledge Base</Link>
              <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            </div>

            <div className="footer-col">
              <h4 className="footer-col-title">Company</h4>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/leadership" className="footer-link">Leadership & Expertise</Link>
              <Link to="/certifications" className="footer-link">Certifications</Link>
              <Link to="/careers" className="footer-link">Careers</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <div className="footer-socials">
              <a
                href="https://www.linkedin.com/company/proven-infosec-pvt-ltd"
                className="footer-social"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </div>
          </div>
          <div className="footer-copy">
            © {new Date().getFullYear()} Proven Infosec. All Rights Reserved. · {data.jurisdiction} · Governed by {data.privacyLaw}
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
};

export default Footer;
